export default __webpack_public_path__ + "media/images/react_icons/private-pool-118480b9b1ef1550ee652bc9408452ff.svg";